module.exports = __webpack_public_path__ + "static/media/Bulk_transporters_master_update_file.73f31375.csv";